module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/first-time-rc-92a7db29b52f3a4b3f5251f532a6c447.png";